module.exports = "pegasus/assets/hexagon-facebook.gif";